export const MC_SIGNUP_FORMS = {
    'event-organiser': 'https://nightdistrict.us17.list-manage.com/subscribe/post?u=94d2a2af89e56e794d1ee97b5&id=42029140aa',
    'gig-goer': 'https://nightdistrict.us17.list-manage.com/subscribe/post?u=94d2a2af89e56e794d1ee97b5&amp;id=b7bb2d0cbc'
};

export const SELECTORS = {
    accountTypeInput:                       '[data-hook="account-type-input"]',
    conditionalField:                       '[data-hook="conditional-field"]',
    field:                                    '[data-hook="field"]',
    registerForm:                           '[data-hook="register-form"]',
    registerFormSuccessModal:               '[data-hook="registerFormSuccessModal"]',
    registerFormSuccessModalCloseButton:    '[data-hook="registerFormSuccessModalCloseButton"]',
    registerAsButton:                       '[data-hook="register-button"]',
    searchCitiesInput:                      '[data-hook="search-cities-input"]',
    scrollButton:                           '[href^="#"]'
};



// WEBPACK FOOTER //
// ./client/js/config/app.js